import { ChangeDetectorRef, Component, computed, Inject, linkedSignal, OnInit, signal, ViewChild } from '@angular/core';
import { PopoverController, IonDatetime, ModalController } from '@ionic/angular';
import { IMultiTableTournamentState, ISitNGoTournamentState, EditSngPayload, EditMttPayload, TableType, GameType, BountyFormat, LimitTypesMap, PrizeTypes, MTTPrizeTypes, STARTING_CHIPS, StartingChips, BLINDS_TIMERS, BlindsTimer, Felt, Background, TournamentStatus, IMultiDayTournamentSettings, DEFAULT_BOUNTY_SETTINGS, } from '@soposopo/sopo-models';
import { ApiService } from 'src/app/core/backend/api.service';
import { AuthStoreDispatcher } from 'src/app/core/state/auth/auth.dispatcher';
import { combineLatest, map, Observable, Subscription } from 'rxjs';
import moment from 'moment';
import { environment } from 'src/environments/environment';
import { ClubService } from 'src/app/core/firebase/club.service';
import { Firestore, collection, doc, docData, getCountFromServer } from '@angular/fire/firestore';
import { GameSettingsService } from 'src/app/core/firebase/gameSettings.service';
import { DEFAULT_DISMISS_AFTER_TIME, SopoPopupService } from 'src/app/sopo-popup/service/sopo-popup.service';
import { SopoAlertSettings } from 'src/app/sopo-popup/interfaces/alert';
import { SOPO_DIALOG_DATA, SopoDialogRef } from 'src/app/sopo-popup/interfaces/dialog';
import { trigger, transition, style, animate } from '@angular/animations';
import { GameThemeSettingsDispatcher } from 'src/app/core/state/gameThemeSettings/gameThemeSettings.dispatcher';
import { MTT_BLIND_STRUCTURES, MttBlindStructureType, SngBlindStructureType } from '@soposopo/sopo-models/dist/blinds/blinds';

@Component({
    selector: 'app-edit-tournament',
    templateUrl: './edit-tournament.component.html',
    styleUrls: ['./edit-tournament.component.scss'],
    animations: [
        trigger('slideRight', [
            transition(':enter', [
                style({ opacity: 0, 'transform': 'translateX(-350px)' }),
                animate('0.2s ease-in-out', style({ opacity: 1, 'transform': 'translateX(0px)' }))
            ])
        ]),
        trigger('slideLeft', [
            transition(':enter', [
                style({ opacity: 0, 'transform': 'translateX(350px)' }),
                animate('0.2s ease-in-out', style({ opacity: 1, 'transform': 'translateX(0px)' }))
            ])
        ]),
    ],
    standalone: false
})
export class EditTournamentComponent implements OnInit {
    @ViewChild('dateTime') sTime: IonDatetime;

    public sngTournament: EditSngPayload;
    public mttTournament: EditMttPayload;
    public tournamentType: TableType;
    public breakPeriodOptions: Array<{ text: string; value: number }> = [
        { text: 'Disabled', value: 0 },
        { text: '30 minutes', value: 30 },
        { text: '45 minutes', value: 45 },
        { text: '60 minutes', value: 60 },
    ];
    public breakLengthOptions = [2, 5, 10, 15];
    public bountyFormat: BountyFormat = BountyFormat.NONE;
    public bountyFormats: BountyFormat[] = [BountyFormat.NONE, BountyFormat.FLAT, BountyFormat.PKO, BountyFormat.MYSTERY];
    public BountyFormatEnum = BountyFormat;
    public maxHumanOptions = [9, 20, 30, 50, 100, 200, 300, 400, 500, 1000, 3000];
    public seatOptions = [2, 3, 4, 5, 6, 7, 8, 9];
    public lateRegisterOptions = [0, 5, 10, 15, 20, 30, 45, 60];
    public botOptions = [5, 10, 15, 20, 50, 100, 200, 300, 400, 500, 1000, 1200, 1500, 1700, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000];
    public startingChipsOptions: StartingChips[] = STARTING_CHIPS;
    public blindsTimerOptions: BlindsTimer[] = BLINDS_TIMERS;
    public gameTypes = [GameType.HoldEm, GameType.Omaha, GameType.Omaha5];
    public limitTypes = [LimitTypesMap.NL, LimitTypesMap.PL];
    public buyIn: number;
    public isQuickplay = false;
    public isFreeRoll = false;
    public allowBots: boolean;
    public bots: number;
    public maxNrOfBots: number = 0;
    validBotOptions: number[] = [];
    public timebankPerHandOptions: Array<{ text: string, value: number }> = [
        { text: 'No Timebank', value: 0 },
        { text: '1', value: 1 },
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },

    ]
    public rebuyLimitOptions: Array<{ text: string; value: number }> = [
        { text: 'No Rebuy', value: 0 },
        { text: '1x', value: 1 },
        { text: '2x', value: 2 },
        { text: '3x', value: 3 },
        { text: 'Unlimited', value: 1000 },
    ];
    public rebuyPriceMultiplierOptions = [1, 1.5, 2, 2.5, 3];
    public rebuyPriceMultiplier: number;
    public addonPeriodOptions: Array<{ text: string, value: number }> = [
        { text: 'No Addon Period', value: 0 },
        { text: '1', value: 60000 },
        { text: '2', value: 120000 },
        { text: '3', value: 180000 },
        { text: '5', value: 300000 },
    ];
    public addonPriceMultiplierOptions = [1, 1.5, 2, 2.5, 3];
    public addonPriceMultiplier: number;
    public prizeTypes = {
        SNG: [PrizeTypes.WINNER_TO_TAKE_ALL, PrizeTypes.TOP_TWO, PrizeTypes.TOP_THREE],
        MTT: [
            MTTPrizeTypes.WINNER_TO_TAKE_ALL,
            MTTPrizeTypes.TOP_TWO,
            MTTPrizeTypes.TOP_THREE,
            MTTPrizeTypes.TOP_10_PERCENT,
            MTTPrizeTypes.TOP_15_PERCENT,
            MTTPrizeTypes.TOP_20_PERCENT,
        ],
    };
    public winnerPrize: number;
    public secondPrize: number;
    public thirdPrize: number;
    public isTop2 = false;
    public isTop3 = false;
    public forceFeltAndBackground = false;
    public selectedFelt: Felt | undefined;
    public selectedBackground: Background | undefined;
    public felts: Felt[] = [];
    public backgrounds: Background[] = [];
    private feltsSubscription: Subscription | undefined;
    private backgroundsSubscription: Subscription | undefined;
    public lateRegPeriodInMinutes: number;
    public tournamentStatusSubscription: Subscription;
    public playersRegisteredSubscription: Subscription;
    public numberOfRegisteredPlayers: number;
    public startDate: Date;
    minTimeIsoString = '';
    maxTimeIsoString = '';
    selectedTimeIsoString = '';
    prizeStructure: number[] | false;
    isStaging = false;
    collectWallettAddressAndTwitter = false;
    maxForLateReg = 300;
    maxForLateRegSubscription: Subscription;
    restriction = false;
    editTournamentPopoverId = 'edit-tournament-popover-id';
    private _popoverOpened = false;

    activeCommunityFeltMenu = false;

    currentlySetMaxHumanPlayers = 0;
    public mainStage = false;
    public winningAmounts = [50, 100, 150, 200, 250, 300, 400, 500, 750, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 15000, 20000, 25000, 30000, 35000, 40000, 45000, 50000];

    startTimeIsoString = '';
    multiDayTournamentSettings: IMultiDayTournamentSettings = {
        levelsArray: [],
        nextStopIndex: null,
        stoppedAt: null,
    };

    public sngBlindStructureType: SngBlindStructureType[] = ['StandardV2', 'Standard', 'Yeet'];
    public mttBlindStructureType: MttBlindStructureType[] = ['StandardV2', 'Standard', 'Yeet'];
    public selectedSngBlindsStructureType: SngBlindStructureType = 'StandardV2';
    public selectedMttBlindsStructureType = signal<MttBlindStructureType>('StandardV2');


    onBountyFormatChange(format: BountyFormat) {
        this.bountyFormat = format;
        this.mttTournament.mttBountySettings.format = format;
        if (format === BountyFormat.NONE) {
            this.mttTournament.mttBountySettings = { ...DEFAULT_BOUNTY_SETTINGS };
            return;
        }
        if (this.mttTournament.mttBountySettings.contributionPercent <= 0) {
            this.mttTournament.mttBountySettings.contributionPercent = 50;
        }
    }

    enableRemoveAfkPlayers = signal(false);
    selectedAfkType = signal<string>("Blind Level");
    // selectableAfkTypes = ["Hand", "Blind Level"]; Hand is currently disabled
    selectableAfkTypes = ["Blind Level"];
    afkHandOptions = [15, 20, 25, 30, 35, 40, 50, 60, 70, 80, 90, 100];
    selectedAfkHandValue = signal(15);
    selectedAfkBlindValue = linkedSignal<MttBlindStructureType, number | null>({
        source: () => this.selectedMttBlindsStructureType(),
        computation: (structure, previous) => {
            const levels = MTT_BLIND_STRUCTURES[structure]?.map(x => x.level) ?? [];

            if (previous?.value && levels.includes(previous.value)) {
                return previous.value;
            }

            return levels.includes(4) ? 4 : levels[0] ?? 1;
        }
    });
    selectableOptions = computed(() => {
        if (this.selectedAfkType() === "Hand") {
            return this.afkHandOptions;
        }
        return MTT_BLIND_STRUCTURES[this.selectedMttBlindsStructureType()].map(x => x.level) ?? [];
    });

    selectedAfkAmount = computed(() =>
        this.selectedAfkType() === "Blind Level"
            ? this.selectedAfkBlindValue()
            : this.selectedAfkHandValue()
    );
    sopoDateOptions: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
    };

    constructor(
        @Inject(SOPO_DIALOG_DATA) public data: {
            state: IMultiTableTournamentState | ISitNGoTournamentState,
            tournamentStatus$: Observable<TournamentStatus>,
            playersRegistered$: Observable<number>
        },
        private sopoDialogRef: SopoDialogRef,
        public authService: AuthStoreDispatcher,
        private apiService: ApiService,
        private clubService: ClubService,
        private firestore: Firestore,
        private ref: ChangeDetectorRef,
        private popoverCtrl: PopoverController,
        private sopoPopupService: SopoPopupService,
        private gameThemeSettingsDispatcher: GameThemeSettingsDispatcher,
        private gameSettingsService: GameSettingsService,
        public modalController: ModalController,
    ) {
        this.tournamentType = data.state.tournamentType as TableType;
        this.isQuickplay = data.state.isQuickplay;
        this.isFreeRoll = data.state.rules['isFreeRoll'];
        switch (this.tournamentType) {
            case TableType.MTT:
                this.mttTournament = this.setInitialMttData(data.state as IMultiTableTournamentState);
                break;
            case TableType.SNG:
                this.sngTournament = this.setInitialSngData(data.state as ISitNGoTournamentState)
                break;
        }
        this.setMinMaxTime(new Date());
    }

    ngOnInit() {
        this.initializeSubscriptions();
        this.setInitValues();
        this.isStaging = environment.staging;
        if(this.isStaging) {
            this.lateRegisterOptions = [0, 5, 10, 15, 20, 30, 45, 60, 1];
            this.breakPeriodOptions = [
                { text: '30 minutes', value: 30 },
                { text: '45 minutes', value: 45 },
                { text: '60 minutes', value: 60 },
                { text: '3 minutes', value: 3 },
                { text: '1 minutes', value: 1 },
                { text: 'Disabled', value: 0 },
            ];
            this.breakLengthOptions = [2, 5, 10, 15, 1];
            this.maxHumanOptions = [9, 20, 30, 50, 100, 200, 300, 400, 500, 1000, 2000, 3000, 4000, 5000];
            this.initBotNumber();
        }
    }

    private initializeSubscriptions() {
        this.tournamentStatusSubscription = this.data.tournamentStatus$.subscribe(tournamentStatus => {
            if (tournamentStatus !== TournamentStatus.WAITING_FOR_PLAYERS)
                this.close();
        });

        this.playersRegisteredSubscription = this.data.playersRegistered$.subscribe(playersRegistered => {
            this.numberOfRegisteredPlayers = playersRegistered;
        });

        if (this.tournamentType === TableType.MTT) {
            const docReference = doc(this.firestore, 'config/tournament-settings');
            this.maxForLateRegSubscription = docData(docReference).subscribe(tournamentSettings => {
                if (tournamentSettings && tournamentSettings.maxForLateReg !== undefined) {
                    this.maxForLateReg = tournamentSettings.maxForLateReg;
                } else {
                    this.maxForLateReg = 300;
                }
                this.restrictionMaxHumen(this.mttTournament.mttRules.maxHumanPlayers);
                this.ref.detectChanges();
            });
        }

        this.feltsSubscription = combineLatest([this.gameSettingsService.loadAllItemsFromCms<Felt>('felts'), this.gameThemeSettingsDispatcher.getMyFeltsState()]).pipe(
            map(([felts, myFelts]) => this.gameSettingsService.mergeItems(myFelts, felts)),
        ).subscribe(felts => {
            this.felts = felts;
            if (felts.length && !this.selectedFelt) this.selectedFelt = felts[0];
            this.ref.detectChanges();
        });

        this.backgroundsSubscription = combineLatest([this.gameSettingsService.loadAllItemsFromCms<Background>('backgrounds') , this.gameThemeSettingsDispatcher.getMyBackgroundsState()]).pipe(
            map(([backgrounds, myBackgrounds]) => this.gameSettingsService.mergeItems(myBackgrounds, backgrounds)),
        ).subscribe(backgrounds => {
            this.backgrounds = backgrounds;
            if (backgrounds.length && !this.selectedBackground) this.selectedBackground = backgrounds[0];
            this.ref.detectChanges();
        });
    }

    private setInitValues() {
        switch (this.tournamentType) {
            case TableType.MTT:
                this.getServerTime();
                this.startDate = new Date(this.mttTournament.mttSettings.startingDate);
                this.selectedTimeIsoString = moment(this.startDate).toISOString(true);
                if (this.mttTournament.mttSettings.forceFeltAndBackground) {
                    this.selectedFelt = this.mttTournament.mttSettings.forcedSettings!.felt;
                    this.selectedFelt.id = parseInt(GameSettingsService.getFeltId(this.selectedFelt.id));
                    this.selectedBackground = this.mttTournament.mttSettings.forcedSettings!.background;
                    this.selectedBackground.id = parseInt(GameSettingsService.getBackgroundId(this.selectedBackground.id));
                }
                this.allowBots = this.mttTournament.mttRules.minNrOfBots > 0 ? true : false;
                this.bots = this.allowBots ? this.mttTournament.mttRules.minNrOfBots : 0;
                this.winnerPrize = (this.mttTournament.mttRules.prizeStructure as number[])[0] * 10;
                this.secondPrize = (this.mttTournament.mttRules.prizeStructure as number[])[1] * 10;
                this.thirdPrize = (this.mttTournament.mttRules.prizeStructure as number[])[2] * 10;
                this.isTop2 = (this.mttTournament.mttRules.prizeType == MTTPrizeTypes.TOP_TWO);
                this.isTop3 = (this.mttTournament.mttRules.prizeType == MTTPrizeTypes.TOP_THREE);
                if (this.mttTournament.mttRules.maxHumanPlayers > this.maxForLateReg) this.restriction = true;
                if (this.mttTournament.mttSettings.removePlayerAfterHands) {
                    this.enableRemoveAfkPlayers.set(true);
                    this.selectedAfkType.set("Hand");
                    this.selectedAfkHandValue.set(this.mttTournament.mttSettings.removePlayerAfterHands!);
                }
                if (this.mttTournament.mttSettings.removePlayerAfterBlindLevels) {
                    this.enableRemoveAfkPlayers.set(true);
                    this.selectedAfkType.set("Blind Level");
                    this.selectedAfkBlindValue.set(this.mttTournament.mttSettings.removePlayerAfterBlindLevels!);
                }
                break;
            case TableType.SNG:
                if (this.sngTournament.sngSettings.forceFeltAndBackground) {
                    this.selectedFelt = this.sngTournament.sngSettings.forcedSettings!.felt;
                    this.selectedFelt.id = parseInt(GameSettingsService.getFeltId(this.selectedFelt.id));
                    this.selectedBackground = this.sngTournament.sngSettings.forcedSettings!.background;
                    this.selectedBackground.id = parseInt(GameSettingsService.getBackgroundId(this.selectedBackground.id));
                }
                this.winnerPrize = (this.sngTournament.sngRules.prizeStructure as number[])[0] * 10;
                this.secondPrize = (this.sngTournament.sngRules.prizeStructure as number[])[1] * 10;
                this.thirdPrize = (this.sngTournament.sngRules.prizeStructure as number[])[2] * 10;
                this.isTop2 = (this.sngTournament.sngRules.prizeType == MTTPrizeTypes.TOP_TWO);
                this.isTop3 = (this.sngTournament.sngRules.prizeType == MTTPrizeTypes.TOP_THREE);
                break;
        }

    }

    async initBotNumber() {
        if (!this.isQuickplay) {
            this.maxNrOfBots = await this.clubService.getBotNumber();
        } else {
            this.maxNrOfBots = await this.getBotNumberForQuickPlay();
        }
        this.validBotOptions = this.botOptions.filter(bot => bot <= this.maxNrOfBots);
    }

    async getBotNumberForQuickPlay() {
        const collectionReference = collection(this.firestore, `bots`);
        return (await getCountFromServer(collectionReference)).data().count;
    }

    setMinMaxTime(date: Date): void {
        date.setSeconds(0);
        date.setMilliseconds(0);

        const isoString = moment(date).toISOString(true);

        this.startTimeIsoString = isoString;
        this.minTimeIsoString = isoString;

        date.setFullYear(date.getFullYear() + 1);

        this.maxTimeIsoString = moment(date).toISOString(true);
    }

    close() {
        this.modalController.getTop().then((v) => {
            if (v) {
                this.modalController.dismiss();
            }
        });
        this.sopoDialogRef.close();
    }

    setInitialMttData(state: IMultiTableTournamentState): EditMttPayload {
        //set values for the payload object from the incoming state
        let tournamentObject: EditMttPayload = {
            adminId: '',
            clubId: state.clubID,
            mttRules: {
                gameMode: state.rules.gameMode,
                startingChips: state.rules.startingChips,
                blindsTime: state.rules.blindsTime,
                prizeType: state.rules.prizeType,
                prizeStructure: state.rules.prizeStructure,
                maxHumanPlayers: state.rules.maxHumanPlayers,
                timebankPerHand: state.rules.timebankPerHand,
                seats: state.rules.seats,
                rebuyLimit: state.rules.rebuyLimit,
                rebuyPrice: state.rules.rebuyPrice,
                addonPeriod: state.rules.addonPeriod,
                addonPrice: state.rules.addonPrice,
                minNrOfBots: state.rules.minNrOfBots,
                winningAmount: state.rules.winningAmount,
                blindStructureType: state.rules.blindStructureType,
            },
            mttSettings: {
                name: state.settings.name,
                requireKyc: state.settings.requireKyc,
                forceFeltAndBackground: state.settings.forceFeltAndBackground,
                forcedSettings: state.settings.forcedSettings,
                restricted: state.settings.restricted,
                breakPeriod: state.settings.breakPeriod,
                breakLength: state.settings.breakLength,
                lateRegistrationPeriod: state.settings.lateRegistrationPeriod,
                startingDate: state.settings.startingDate,
                collectWalletAddress: state.settings.collectWalletAddress,
                removePlayerAfterBlindLevels: state.settings.removePlayerAfterBlindLevels,
                removePlayerAfterHands: state.settings.removePlayerAfterHands,
            },
            // Forward the entire bounty settings shape so the new MTT Bounty Suite
            // fields round-trip through the edit payload (format, contributionPercent,
            // sponsoredBountyPool, mystery envelope mode / list / curve preset / count).
            mttBountySettings: { ...state.bountySettings },
            multiDayTournamentSettings: state.multiDayTournamentSettings,
        }

        //set global variables from the incoming state
        // Sync bountyFormat from the loaded tournament so the format selector and
        // the *ngIf-gated bounty config block reflect the existing FLAT/PKO/MYSTERY
        // configuration; without this it would always read NONE on edit.
        this.bountyFormat = state.bountySettings.format;
        this.buyIn = state.rules.buyIn;
        this.lateRegPeriodInMinutes = tournamentObject.mttSettings.lateRegistrationPeriod / 60000;
        this.addonPriceMultiplier = tournamentObject.mttRules.addonPrice ?
            tournamentObject.mttRules.addonPrice / this.buyIn :
            0;
        this.rebuyPriceMultiplier = tournamentObject.mttRules.rebuyPrice ?
            tournamentObject.mttRules.rebuyPrice / this.buyIn :
            0;
        if (state.settings.mainStage) {
            this.mainStage = state.settings.mainStage;
            tournamentObject.mttSettings.restricted = true;
        }
        this.currentlySetMaxHumanPlayers = tournamentObject.mttRules.maxHumanPlayers;
        this.multiDayTournamentSettings = {
            levelsArray: tournamentObject.multiDayTournamentSettings.levelsArray,
            nextStopIndex: tournamentObject.multiDayTournamentSettings.nextStopIndex,
            stoppedAt: tournamentObject.multiDayTournamentSettings.stoppedAt,
        };
        this.selectedMttBlindsStructureType.set(tournamentObject.mttRules.blindStructureType);
        return tournamentObject;
    }

    setInitialSngData(state: ISitNGoTournamentState): EditSngPayload {
        let tournamentObject: EditSngPayload = {
            adminId: '',
            clubId: state.clubID,
            sngRules: {
                gameMode: state.rules.gameMode,
                prizeType: state.rules.prizeType,
                prizeStructure: state.rules.prizeStructure,
                startingChips: state.rules.startingChips,
                blindsTime: state.rules.blindsTime,
                blindStructureType: state.rules.blindStructureType as SngBlindStructureType,
                timebankPerHand: state.rules.timebankPerHand,
                seats: state.rules.seats,
            },
            sngSettings: {
                name: state.settings.name,
                forceFeltAndBackground: state.settings.forceFeltAndBackground,
                forcedSettings: state.settings.forcedSettings,
                restricted: state.settings.restricted,
                collectWalletAddress: state.settings.collectWalletAddress,
            }
        }

        //set global variables from the incoming state
        if (state.settings.mainStage) {
            this.mainStage = state.settings.mainStage;
            tournamentObject.sngSettings.restricted = true;
        }

        this.selectedSngBlindsStructureType = state.rules.blindStructureType as SngBlindStructureType;

        return tournamentObject;
    }

    resetBounty() {
        this.mttTournament.mttBountySettings = { ...DEFAULT_BOUNTY_SETTINGS };
        this.bountyFormat = BountyFormat.NONE;
    }

    onTypeChange(event: any) {
        if (event == 'Top Two') {
            this.isTop2 = true;
            this.isTop3 = false;
            this.winnerPrize = 70;
            this.secondPrize = 30;
        } else if (event == 'Top Three') {
            this.isTop2 = true;
            this.isTop3 = true;
            this.winnerPrize = 60;
            this.secondPrize = 30;
            this.thirdPrize = 10;
        } else {
            this.isTop2 = false;
            this.isTop3 = false;
        }
    }

    restrictionMaxHumen(maxPlayers: number) {
        if (maxPlayers > this.maxForLateReg) {
            this.restriction = true;
            this.lateRegPeriodInMinutes = 0;
        } else {
            this.restriction = false;
        }
    }

    calcAndValidatePrize() {
        const prizeType =
            this.tournamentType === TableType.MTT ?
                this.mttTournament.mttRules.prizeType :
                this.sngTournament.sngRules.prizeType
        const totalPrize = 100;
        let chosenPrize = 100;
        let prizeStructure = [1];
        this.winnerPrize = this.chipsRoundUp(this.winnerPrize);
        this.secondPrize = this.chipsRoundUp(this.secondPrize);
        this.thirdPrize = this.chipsRoundUp(this.thirdPrize);
        if (prizeType === 'Top Two') {
            if (this.winnerPrize < this.secondPrize) {
                let msg = 'Winner prize should be more than second prize.';
                this.showError(msg);
                return false;
            }
            chosenPrize = this.chipsRoundUp(this.winnerPrize + this.secondPrize);
            prizeStructure = [
                this.chipsRoundUp(this.winnerPrize * 0.1),
                this.chipsRoundUp(this.secondPrize * 0.1)
            ];
        }
        if (prizeType === 'Top Three') {
            if (this.winnerPrize < this.secondPrize) {
                let msg = 'Winner prize should be more than second prize.';
                this.showError(msg);
                return false;
            }
            if (this.winnerPrize < this.thirdPrize) {
                let msg = 'Winner prize should be more than third prize.';
                this.showError(msg);
                return false;
            }
            if (this.secondPrize < this.thirdPrize) {
                let msg = 'Second prize should be more than third prize.';
                this.showError(msg);
                return false;
            }
            chosenPrize = this.winnerPrize + this.secondPrize + this.thirdPrize;
            prizeStructure = [
                this.chipsRoundUp(this.winnerPrize * 0.1),
                this.chipsRoundUp(this.secondPrize * 0.1),
                this.chipsRoundUp(this.thirdPrize * 0.1),
            ];
        }
        if (chosenPrize != totalPrize) {
            let msg = 'Total prize should be 100%';
            this.showError(msg);
            return false;
        }
        return prizeStructure;
    }

    chipsRoundUp(chips) {
        return parseFloat(chips.toFixed(2));
    }

    async showError(message: string) {
        const sopoAlertSettings: SopoAlertSettings = {
            message,
            dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
        };
        this.sopoPopupService.showAlert('app', sopoAlertSettings);
    }

    async showConfirmWarning(message: string) {
        const result = await this.sopoPopupService.promptForConfirmation('app', {
            data: {
                body: message,
                header: 'Warning',
                okText: 'Ok',
                cancelText: 'Cancel',
            },
            sCss: ['sopo-popup-red-background'],
        })
        return result;
    }

    setFelt(felt: Felt) {
        this.selectedFelt = felt;
        this.ref.detectChanges();
    }

    setBackground(background: Background) {
        this.selectedBackground = background;
        this.ref.detectChanges();
    }

    validateName(name) {
        if (name.trim() == '') {
            return false;
        }
        return true;
    }

    async validateDate(time: string): Promise<boolean> {
        if (!time) {
            this.showError('Please select valid Date and Time');
            return false;
        }

        const maxHumans = this.mttTournament.mttRules.maxHumanPlayers;
        const validateTime = new Date(time).getTime();
        const currentTime = Date.now();
        const tenMinuteTime = currentTime + 10 * 60000;
        const thirtyMinuteTime = currentTime + 30 * 60000;

        if (maxHumans < 300) {
            if (validateTime >= tenMinuteTime) return true;
            if (this.isStaging) {
                return this.stagingDateCheck(validateTime, 10);
            }
            else {
                this.showError('Start Date / Time should be greater than the present time by an additional 10 minutes or more.');
                return false;
            }
        } else { // this.maxHumans >= 300
            if (validateTime >= thirtyMinuteTime) return true;

            if (this.isStaging) {
                return this.stagingDateCheck(validateTime, 30);
            } else {
                this.showError('Start Date / Time should be greater than the present time by an additional 30 minutes or more.');
                return false;
            }
        }
    }

    private async stagingDateCheck(validateTime: number, minutes: number): Promise<boolean> {
        const isAfter = this.isAfterCurrentTime(validateTime);
        if (!isAfter) return false;
        const answer = await this.showConfirmWarning(`This would not be tolerated in production proceed on your own responsibility. Start Date / Time should be greater than the present time by an additional ${minutes} minutes or more.`);
        if (answer) {
            return this.isAfterCurrentTime(validateTime);
        }
        return false;
    }

    private isAfterCurrentTime(time: number): boolean {
        if (time <= Date.now()) {
            this.showError('Start Date / Time should be greater than the present time');
            return false;
        } else {
            return true;
        }
    }

    async getServerTime() {
        const serverTime = await this.apiService.getServerTime();
        this.setMinMaxTime(new Date(serverTime * 1000));
    }

    async editTournament() {
        let finalData: EditMttPayload | EditSngPayload = Object();

        switch (this.tournamentType) {
            case TableType.MTT:
                finalData = this.mttTournament;
                (finalData as EditMttPayload).mttSettings.lateRegistrationPeriod = this.lateRegPeriodInMinutes * 60000;
                if ((finalData as EditMttPayload).mttSettings.forceFeltAndBackground) {
                    (finalData as EditMttPayload).mttSettings.forcedSettings = {
                        background: this.selectedBackground,
                        felt: this.selectedFelt,
                    };

                    if ((finalData as EditMttPayload).mttSettings.forcedSettings.background === undefined || (finalData as EditMttPayload).mttSettings.forcedSettings.felt === undefined ) {
                        (finalData as EditMttPayload).mttSettings.forceFeltAndBackground = false;
                        (finalData as EditMttPayload).mttSettings.forcedSettings = null;
                    }
                }
                (finalData as EditMttPayload).mttRules.rebuyPrice = this.rebuyPriceMultiplier * this.buyIn;
                (finalData as EditMttPayload).mttRules.addonPrice = this.addonPriceMultiplier * this.buyIn;
                (finalData as EditMttPayload).mttSettings.startingDate = new Date(this.selectedTimeIsoString).getTime();
                (finalData as EditMttPayload).mttRules.minNrOfBots = (this.allowBots && this.bots) || 0;
                this.prizeStructure = this.calcAndValidatePrize();
                if (this.prizeStructure) (finalData as EditMttPayload).mttRules.prizeStructure = this.prizeStructure as [];

                if (this.multiDayTournamentSettings.levelsArray.length) {
                    this.multiDayTournamentSettings.nextStopIndex = 0;
                }
                (finalData as EditMttPayload).multiDayTournamentSettings = this.multiDayTournamentSettings;
                (finalData as EditMttPayload).mttRules.blindStructureType = this.selectedMttBlindsStructureType();
                (finalData as EditMttPayload).mttSettings.removePlayerAfterBlindLevels = this.enableRemoveAfkPlayers() ? this.selectedAfkType() === "Blind Level" ? this.selectedAfkBlindValue() : null : null;
                (finalData as EditMttPayload).mttSettings.removePlayerAfterHands = this.enableRemoveAfkPlayers() ? this.selectedAfkType() === "Hand" ? this.selectedAfkHandValue() : null : null;
                break;
            case TableType.SNG:
                finalData = this.sngTournament
                if ((finalData as EditSngPayload).sngSettings.forceFeltAndBackground) {
                    (finalData as EditSngPayload).sngSettings.forcedSettings = {
                        background: this.selectedBackground,
                        felt: this.selectedFelt,
                    };

                    if ((finalData as EditSngPayload).sngSettings.forcedSettings.background === undefined || (finalData as EditSngPayload).sngSettings.forcedSettings.felt === undefined ) {
                        (finalData as EditSngPayload).sngSettings.forceFeltAndBackground = false;
                        (finalData as EditSngPayload).sngSettings.forcedSettings = null;
                    }
                }
                this.prizeStructure = this.calcAndValidatePrize();
                if (this.prizeStructure) (finalData as EditSngPayload).sngRules.prizeStructure = this.prizeStructure as [];
                (finalData as EditSngPayload).sngRules.blindStructureType = this.selectedSngBlindsStructureType;
                break;
        }
        if (await this.isValidModifiedData()) this.sopoDialogRef.close(finalData);
    }

    async isValidModifiedData() {
        const isValidName = this.tournamentType === TableType.MTT ?
            this.validateName(this.mttTournament.mttSettings.name) :
            this.validateName(this.sngTournament.sngSettings.name);

        const modifiedMaxPlayers = this.tournamentType === TableType.MTT ?
            this.mttTournament.mttRules.maxHumanPlayers :
            this.sngTournament.sngRules.seats;

        if (this.prizeStructure === false) {
            return false;
        }

        if (!isValidName) {
            this.showError('Invalid tablename.');
            return false;
        }

        if (this.numberOfRegisteredPlayers > modifiedMaxPlayers) {
            this.showError('Invalid number of seats. You cannot set the max. player number lower than the already registered players.');
            return false;
        }

        if (this.tournamentType === TableType.MTT) {
            const dateChanged = this.startDate.getTime() !== new Date(this.selectedTimeIsoString).getTime();
            const dateTimeIncreased = this.startDate.getTime() < new Date(this.selectedTimeIsoString).getTime();
            const maxHumanPlayersChanged = this.currentlySetMaxHumanPlayers !== this.mttTournament.mttRules.maxHumanPlayers;
            const maxHumanIncreasedBeyondTreshold = this.currentlySetMaxHumanPlayers < 300 && this.mttTournament.mttRules.maxHumanPlayers >= 300;
            if(!dateTimeIncreased || maxHumanPlayersChanged) {
                if(dateChanged || (maxHumanPlayersChanged && maxHumanIncreasedBeyondTreshold)) {
                    const dateValid = await this.validateDate(this.selectedTimeIsoString);
                    return dateValid;
                }
            }
        }

        return true;
    }

    async checkLateReg(selectedValue) {
        if (selectedValue === 0) return;
        if (this.lateRegPeriodInMinutes !== 0) return;
        this.showRebuyAlert();
    }

    async checkRebuy(selectedValue) {
        if (selectedValue !== 0) return;
        if (this.mttTournament.mttRules.rebuyLimit === 0) return;
        this.showRebuyAlert();
    }

    showRebuyAlert() {
        this.sopoPopupService.showAlert('app', {
            header: 'Warning',
            message: 'Rebuy is only possible during late registration.',
            dismissAfter: DEFAULT_DISMISS_AFTER_TIME,
        })
    }

    // checkBountySettings is obsolete under the MTT Bounty Suite: contribution is
    // expressed as a percent of post-fee buy-in, so there is no fixed chip value
    // to clamp against the winning amount.

    onClick() {
        if (!this._popoverOpened) this._popoverOpened = true;
    }

    onDismiss() {
        if (this._popoverOpened) this._popoverOpened = false;
    }

    activateCommunityFeltsMenu() {
        this.activeCommunityFeltMenu = true;
    }

    deActivateCommunityFeltsMenu(event: boolean) {
        this.activeCommunityFeltMenu = event;
    }

    onDateChange() {
        this.multiDayTournamentSettings.levelsArray = [];
    }

    async showMultiDaySettingsInput() {
        const blindStructure = MTT_BLIND_STRUCTURES[this.selectedMttBlindsStructureType()];

        const blinds = blindStructure.map(level => {
            if (level.ante)
                return `${level.smallBlind}/${level.bigBlind}/${level.ante}`;
            return `${level.smallBlind}/${level.bigBlind}`;
        });

        let disabledToIndex = 0;
        let minTimeString = this.mttTournament.mttSettings.startingDate ? moment(new Date(this.mttTournament.mttSettings.startingDate)).toISOString(true) : moment().toISOString(true);

        const levelsArrayLength = this.multiDayTournamentSettings.levelsArray.length;
        if (levelsArrayLength){
            disabledToIndex = blinds.findIndex(blind => blind === this.multiDayTournamentSettings.levelsArray[levelsArrayLength - 1].blindLevelToStopAt);
            minTimeString = moment(new Date(this.multiDayTournamentSettings.levelsArray[levelsArrayLength - 1].resumeDate)).toISOString(true);
        }


        const result = await this.sopoPopupService.promptForMultiDaySettings('app', {
            closeButton: true,
            data: {
                blinds,
                disabledToIndex,
                minTimeString,
            }
        });

        if (result) {
            this.multiDayTournamentSettings.levelsArray.push(result);
            this.ref.markForCheck();
        }
    }

    clearTournamentSettingslevelsArray() {
        this.multiDayTournamentSettings.levelsArray = [];
    }

    removeFromLevels(index: number) {
        this.multiDayTournamentSettings.levelsArray.splice(index,1);
        if (this.multiDayTournamentSettings.levelsArray.length === 0) this.multiDayTournamentSettings.nextStopIndex = null;
    }

    onBlindStructureChange(type: MttBlindStructureType) {
        this.selectedMttBlindsStructureType.set(type);
        this.clearTournamentSettingslevelsArray();
    }

    handleAfkAmountChange = (value: number) => {
        if (this.selectedAfkType() === "Blind Level") {
            this.selectedAfkBlindValue.set(value);
        } else {
            this.selectedAfkHandValue.set(value);
        }
    };

    ngOnDestroy() {
        if (this._popoverOpened) this.popoverCtrl.dismiss(this.editTournamentPopoverId);
        if (this.tournamentStatusSubscription) this.tournamentStatusSubscription.unsubscribe();
        if (this.playersRegisteredSubscription) this.playersRegisteredSubscription.unsubscribe();
        if (this.maxForLateRegSubscription) this.maxForLateRegSubscription.unsubscribe();
        if (this.feltsSubscription) this.feltsSubscription.unsubscribe();
        if (this.backgroundsSubscription) this.backgroundsSubscription.unsubscribe();
    }
}
